import React from "react";
import { container_classname } from "../constants";

export interface StatsInfoProps {
    percentage: string;
    label: string;
}

export interface StatsInfo {
    statsInfoText?: string;
    statsInfo?: Array<StatsInfoProps>;
    backgroundColor?: string;
    containerClassName?: string;
}

const statsInfoData: Array<StatsInfoProps> = [
    { percentage: "59%", label: "Reduction in manual intervention" },
    { percentage: "42%", label: "Increase in student engagement rates" },
    { percentage: "39%", label: "Growth in business profits" },
];

export const statsInfoGbColor = "var(--light-grad-1, linear-gradient(103deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%))";

const StatsInfo: React.FC<StatsInfo> = ({ statsInfoText, statsInfo = statsInfoData, backgroundColor = "bg-gray-50", containerClassName }) => {
    return (
        <section className={`py-10 ${backgroundColor}`} style={{ background: backgroundColor }}>
            {statsInfoText && (
                <p className="text-6xl font-semibold max-w-7xl mx-auto pl-10 py-12" style={{ fontFamily: "Degular Display" }}>
                    {statsInfoText}
                </p>
            )}
            <div className={`${container_classname} ${containerClassName ?? "grid md:grid-cols-3 grid-cols-1 justify-between"} px-10`}>
                {statsInfo.map((statsInfo, idx) => (
                    <div key={idx} className="border-l-2 border-solid border-blue-500 pl-6 mb-5 md:mb-0">
                        <p style={{ fontFamily: "Degular Variable" }} className="font-bold text-new-h1">
                            {statsInfo.percentage}
                        </p>
                        <p>{statsInfo.label}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default StatsInfo;
